module.exports = __webpack_public_path__ + "img/bennett.431fe06e.webp";